/**
 * @generated SignedSource<<1c54327770bb06aa9a66a33840cb8d8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchResultListTopicSearchConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: "TopicSearchResultItem";
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"topicSearchResultListTopicSearchConnection">;
  readonly " $fragmentType": "searchResultListTopicSearchConnection";
};
export type searchResultListTopicSearchConnection$key = {
  readonly " $data"?: searchResultListTopicSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultListTopicSearchConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchResultListTopicSearchConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicSearchEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TopicSearchResultItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicSearchResultListTopicSearchConnection"
    }
  ],
  "type": "TopicSearchConnection",
  "abstractKey": null
};

(node as any).hash = "a948b48fb80c004fd8fe052267a17f81";

export default node;
